class NavigationMobile {
  constructor() {
    this.opened = false;
    this.sublistOpened = false;
    this.currentCategory = null;
    this.menu = document.querySelector('.hdr-m-menu');
    this.slider = document.querySelector('.hdr-m-menu-inner');
    this.triggers = [...document.querySelectorAll('.hdr-m-menu-toggle')];
    this.backTrigger = [...document.querySelectorAll('.hdr-m-menu-back')];
    this.mainCategories = [
      ...document.querySelectorAll('.hdr-m-menu-title.has-sublist'),
    ];

    if (this.menu && this.slider && this.triggers && this.mainCategories) {
      this.bindEvents();
    }
  }

  toggle() {
    if (this.opened === true) this.close();
    else this.open();
  }

  open() {
    this.opened = true;
    document.documentElement.classList.add('hdr-m-menu-open');
  }

  close() {
    this.opened = false;
    document.documentElement.classList.remove('hdr-m-menu-open');
    this.closeSubmenu();
  }

  toggleSubmenu(category) {
    if (this.sublistOpened === true) this.closeSubmenu();
    else this.openSubmenu(category);
  }

  openSubmenu(category) {
    const id = category.getAttribute('data-for');
    // let container = document.getElementById(id);
    if (this.currentCategory)
      document.getElementById(this.currentCategory).classList.remove('is-open');

    this.closeSubmenu();

    this.sublistOpened = true;
    this.currentCategory = id;
    document.getElementById(id).classList.add('is-open');
    document.documentElement.classList.add('hdr-m-sublist-open');
  }

  closeSubmenu() {
    this.sublistOpened = false;
    document.documentElement.classList.remove('hdr-m-sublist-open');
  }

  bindEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', event => {
        event.preventDefault();
        this.toggle();
      });
    });

    this.mainCategories.forEach(categoryTrigger => {
      categoryTrigger.addEventListener('click', event => {
        event.preventDefault();
        this.toggleSubmenu(categoryTrigger);
      });
    });

    this.backTrigger.forEach(categoryTrigger => {
      categoryTrigger.addEventListener('click', event => {
        event.preventDefault();
        this.closeSubmenu();
      });
    });
  }
}

export default new NavigationMobile();



// WEBPACK FOOTER //
// ./src/js/navigation-mobile.js